import React, { useEffect, useState } from 'react';
import axiosInstance from './../axiosInstance';
import Logbook from './Logbook';
import { Drawer } from "@mantine/core";

const LogbookDropdown = ({ artId, userId, onClose, language, isOpen, initialLogbookDateTimes, initialArt }) => {
  const [artData, setArtData] = useState(initialArt || null);
  const [logbookDateTimes, setLogbookDateTimes] = useState(initialLogbookDateTimes || []);
  const [loading, setLoading] = useState(!initialLogbookDateTimes);
  const buildTitle = (category, language) => {
    if (language === "en") {
      if (category === 1) {
        return "My watch dates";
      } else if (category === 2) {
        return "My playing dates";
      } else if (category === 3) {
        return "My reading dates";
      }
      return "";
    } else {
      if (category === 1) {
        return "Даты моих просмотров";
      } else if (category === 2) {
        return "Даты, когда я играл(а)";
      } else if (category === 3) {
        return "Даты моих чтений";
      }
    }
    return "";
  }

  useEffect(() => {
    // alert(artId);
    // alert(initialLogbookDateTimes);
    // alert(!initialLogbookDateTimes);
    if (!initialLogbookDateTimes && !initialArt) {
      axiosInstance
        .get(`/arts/${artId}/`)
        .then((response) => {
          setArtData(response.data);
        })
        .catch((error) => {
          console.error(error);
        });

      const logbookUrl = userId 
        ? `/art/logbook/get?artId=${artId}&userId=${userId}` 
        : `/art/logbook/get?artId=${artId}`;
      
      axiosInstance
        .get(logbookUrl)
        .then((response) => {
          setLogbookDateTimes(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    } else {
      setArtData(initialArt);
      setLogbookDateTimes(initialLogbookDateTimes);
    }
  }, [artId, userId, initialLogbookDateTimes]);

  if (loading) {
    return null; // Render nothing while loading
  }

  if (!artData) {
    return <div>Error loading art data.</div>;
  }

  return (
    <Drawer opened={isOpen} onClose={onClose} position="bottom" size="75vh" radius="md" padding="md"
      title={<span style={{ fontWeight: 700, fontSize: '1.1rem' }}>{buildTitle(artData.category, language)}</span>}
      styles={{ title: { flex: 1, textAlign: 'center' } }}
    >
      <div>
        <div className="flex justify-center my-2">
          <img
            className="object-cover rounded-lg max-w-[100px]"
            src={artData.thumbnailUrl}
            alt={artData.name || "Art Thumbnail"}
          />
        </div>
        <div className="flex justify-center">
          <Logbook
            initialDateTimes={logbookDateTimes}
            art={artData}
            language={language}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default LogbookDropdown;
